import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface GetClaimGroupCarrierContextSummaryQueryArgs {
  claimGroupId: string;
}

export const getClaimGroupCarrierContextSummaryRequest = ({
  claimGroupId,
}: GetClaimGroupCarrierContextSummaryQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}/carrier`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimGroupCarrierContextSummaryQuery = async (
  args: GetClaimGroupCarrierContextSummaryQueryArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      getClaimGroupCarrierContextSummaryRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
